import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const GoodAudio = ({ content, title }) => {
    const container = useRef(null);

    if (!content || content?.length === 0) return null;

    return (
        <div className={styles.box}>
            <div className={styles.title}>{title}</div>
            <ul className="clearfix" ref={container}>
                {content.map((item, index) => (
                    <li key={index} className="clearfix">
                        <a href={item.url} target="_blank" title={item.title}>
                            {item.img && item.img !== '' ? <span style={{ background: `url(${item.img})` }} data-img={item.img} /> : ''}
                            <p>{item.title}</p>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

GoodAudio.propTypes = {
    content: PropTypes.array,
    title: PropTypes.string,
};

export default errorBoundary(GoodAudio);
